import { useRouter } from 'next/router'
import useTranslatedRoutes from '../services/translatedRoutes'
import { i18n } from 'next-i18next'

export default function useRouteTranslator () {
  const router = useRouter()

  /**
   * This will return "category" or "software" depending on the current language
   * @returns {T}
   */
  const getRouteTypeFromRoute = routeParts => {
    const i18nRoutes = i18n.getResourceBundle(router.locale, 'routes')

    return Object
      .keys(i18nRoutes)
      .find(route => routeParts[1] === i18nRoutes[route])
  }

  const getHrefLangLink = locale => {
    const routeParts = router.asPath.split('/').filter(item => item)
    const translatedRoutes = useTranslatedRoutes(router.locale)
    const translatedNextRoutes = useTranslatedRoutes(locale)
    const routeType = getRouteTypeFromRoute(routeParts)

    /**
     * If the route type is not found, we take the default route
     */
    if (!routeType) {
      return `${process.env.NEXT_PUBLIC_FRONTEND_URL}${locale === 'en' ? '' : `/${router.locale}`}${router.asPath.split('?')[0]}`
    }

    const getUrlOfType = translatedNextRoutes[`get${routeType.charAt(0).toUpperCase() + routeType.slice(1)}Url`]
    const getValueOfType = translatedRoutes[`get${routeType.charAt(0).toUpperCase() + routeType.slice(1)}Name`](routeParts[2].split('?')[0])

    return `${process.env.NEXT_PUBLIC_FRONTEND_URL}${locale === 'en' ? '' : `/${router.locale}`}${getUrlOfType({ name: getValueOfType })}`
  }

  return {
    getHrefLangLink
  }
}
